var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComingSoonDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 924,
    height: 877,
    viewBox: "0 0 924 877",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M357.408 54.7842L304.016 156.169L326.885 87.9832L300.09 103.443L338.103 11.0564L323.683 74.2409L357.408 54.7842Z",
    fill: "#FBB93E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M357.408 54.7842L323.683 74.2408L328.439 53.3936L341.726 45.7278L357.408 54.7842Z",
    fill: "#FBB93E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M338.103 11.0564L300.09 103.443L284.408 94.387L322.421 2L338.103 11.0564Z",
    fill: "#FBB93E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M326.885 87.983L304.016 156.169L288.334 147.113L303.677 101.375L326.885 87.983Z",
    fill: "#FBB93E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304.016 156.169L357.408 54.7842L323.683 74.2409L338.103 11.0564L300.09 103.443L326.885 87.9832L304.016 156.169Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M300.09 103.443L284.408 94.387L322.421 2L338.103 11.0564",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M304.016 156.169L288.334 147.112L303.677 101.375",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M357.408 54.7842L341.726 45.7278L328.439 53.3936",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M697.239 385.302C697.123 386.073 697.099 386.845 697.169 387.616C697.169 386.833 697.193 386.062 697.239 385.302Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M697.333 384.66C697.287 384.87 697.263 385.08 697.252 385.302C697.135 386.073 697.111 386.845 697.182 387.616",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M709.007 361.463C702.463 366.582 697.836 374.516 697.24 385.302C697.193 386.062 697.169 386.833 697.169 387.616V387.686",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M698.058 391.204L673.915 399.909",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M673.915 399.909C673.214 408.358 665.338 412.693 661.107 413.593",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M271.963 244.957L243.59 228.585C249.316 217.998 257.402 201.019 262.404 181.586C266.505 201.264 270.105 229.415 271.963 244.957Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M174.142 350.549V376.619C167.06 383.619 156.894 392.22 151.273 392.22C149.076 392.22 148.059 390.876 148.059 389.637C148.059 386.774 156.8 377.18 156.8 371.513C156.8 370.765 150.385 347.896 146.727 334.726L174.142 350.549Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M243.602 228.597L294.761 258.127",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M146.727 334.726C150.385 347.896 156.8 370.765 156.8 371.513C156.8 377.18 148.059 386.774 148.059 389.637C148.059 390.876 149.076 392.22 151.273 392.22C156.894 392.22 167.06 383.619 174.142 376.619",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M634.872 185.103V202.608L447.539 310.782V293.277L634.872 185.103Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M634.873 185.103L447.528 293.266L241.007 174.037L428.375 65.874L634.873 185.103ZM513.669 183.677C522.328 178.676 523.274 171.104 515.772 166.78L448.346 127.843C440.844 123.508 427.744 124.057 419.085 129.058L355.854 165.565C347.183 170.566 346.248 178.138 353.75 182.462L421.177 221.399C428.667 225.734 441.778 225.185 450.438 220.183L513.669 183.677Z",
    fill: "#459AA4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M634.861 223.012V519.851L447.528 627.99V331.174L634.861 223.012Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M634.861 223.011L447.528 331.174L241.007 211.956L258.687 201.755L447.539 310.782L617.204 212.81L634.861 223.011Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M515.772 166.768C523.274 171.104 522.328 178.664 513.669 183.666L450.437 220.172C441.778 225.161 428.667 225.711 421.177 221.387L353.75 182.45C346.248 178.115 347.183 170.554 355.854 165.553L419.085 129.047C427.744 124.057 440.844 123.508 448.346 127.831L515.772 166.768ZM505.664 176.619C507.58 175.509 507.58 173.709 505.664 172.599L438.238 133.663C436.321 132.564 433.213 132.564 431.296 133.663L363.87 172.599C361.942 173.709 361.942 175.509 363.87 176.619L431.296 215.556C433.213 216.666 436.321 216.666 438.238 215.556L505.664 176.619Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M505.664 172.611C507.581 173.721 507.581 175.521 505.664 176.631L490.543 185.36L416.164 142.415L431.285 133.686C433.201 132.588 436.31 132.588 438.226 133.686L505.652 172.623L505.664 172.611Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M490.543 185.349L471.951 196.088L397.572 153.143L416.164 142.404L490.543 185.349Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M471.951 196.088L453.359 206.827L378.968 163.882L397.572 153.143L471.951 196.088Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M453.359 206.827L438.238 215.556C436.321 216.666 433.213 216.666 431.296 215.556L363.87 176.619C361.942 175.509 361.942 173.709 363.87 172.599L378.98 163.87L453.371 206.815L453.359 206.827Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M447.54 293.277V310.782L241.019 191.553V174.048L447.54 293.277Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M447.528 331.174V627.99L241.007 508.785V211.945L447.528 331.174ZM432.839 602.527V339.67L255.719 237.408V500.289L432.839 602.527Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M432.839 339.67V602.527L255.719 500.289V237.408L432.839 339.67ZM423.537 582.054V530.321L266.634 439.722V491.467L423.537 582.054ZM423.537 520.611V468.866L266.634 378.279V430.023L423.537 520.611ZM423.537 459.156V407.423L266.634 316.836V368.568L423.537 459.156ZM423.537 397.712V345.98L266.634 255.381V307.125L423.537 397.712Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M423.537 530.321V582.054L266.634 491.466V439.722L423.537 530.321ZM400.844 543.094C400.844 539.109 398.051 534.283 394.615 532.284C391.168 530.298 388.387 531.91 388.387 535.895C388.387 539.88 391.18 544.706 394.615 546.693C398.063 548.679 400.844 547.067 400.844 543.094ZM376.094 528.79C376.094 524.806 373.289 519.979 369.853 517.981C366.406 515.995 363.625 517.607 363.625 521.592C363.625 525.577 366.418 530.403 369.853 532.39C373.301 534.376 376.094 532.764 376.094 528.79ZM351.32 514.499C351.32 510.514 348.527 505.688 345.091 503.69C341.644 501.703 338.863 503.316 338.863 507.3C338.863 511.285 341.656 516.111 345.091 518.098C348.539 520.085 351.32 518.472 351.32 514.499ZM326.558 500.196C326.558 496.211 323.765 491.385 320.329 489.386C316.882 487.4 314.101 489.012 314.101 492.997C314.101 496.982 316.894 501.808 320.329 503.795C323.777 505.781 326.558 504.169 326.558 500.196Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M423.537 468.866V520.61L266.634 430.023V378.279L423.537 468.866ZM400.844 481.627C400.844 477.654 398.051 472.816 394.615 470.829C391.168 468.843 388.387 470.455 388.387 474.429C388.387 478.402 391.18 483.24 394.615 485.238C398.063 487.224 400.844 485.612 400.844 481.627ZM326.558 438.74C326.558 434.767 323.765 429.941 320.329 427.943C316.882 425.956 314.101 427.569 314.101 431.554C314.101 435.539 316.894 440.353 320.329 442.351C323.777 444.338 326.558 442.725 326.558 438.74ZM301.808 424.449C301.808 420.476 299.003 415.65 295.568 413.651C292.12 411.665 289.339 413.277 289.339 417.262C289.339 421.247 292.132 426.073 295.568 428.06C299.015 430.046 301.808 428.434 301.808 424.449Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M423.537 407.423V459.155L266.634 368.568V316.835L423.537 407.423ZM400.844 420.184C400.844 416.199 398.051 411.373 394.615 409.386C391.168 407.388 388.387 409.012 388.387 412.985C388.387 416.958 391.18 421.796 394.615 423.783C398.063 425.781 400.844 424.168 400.844 420.184ZM376.094 405.892C376.094 401.907 373.289 397.081 369.853 395.094C366.406 393.096 363.625 394.721 363.625 398.694C363.625 402.667 366.418 407.505 369.853 409.491C373.301 411.489 376.094 409.877 376.094 405.892ZM301.808 363.006C301.808 359.021 299.003 354.195 295.568 352.208C292.12 350.221 289.339 351.834 289.339 355.807C289.339 359.78 292.132 364.618 295.568 366.616C299.015 368.603 301.808 366.99 301.808 363.006Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M423.537 345.98V397.712L266.634 307.125V255.381L423.537 345.98ZM351.32 330.146C351.32 326.161 348.527 321.335 345.091 319.348C341.644 317.35 338.863 318.962 338.863 322.947C338.863 326.932 341.656 331.758 345.091 333.745C348.539 335.731 351.32 334.119 351.32 330.146ZM326.558 315.854C326.558 311.869 323.765 307.043 320.329 305.056C316.882 303.058 314.101 304.671 314.101 308.656C314.101 312.64 316.894 317.467 320.329 319.453C323.777 321.451 326.558 319.827 326.558 315.854ZM301.808 301.562C301.808 297.578 299.003 292.751 295.568 290.765C292.12 288.767 289.339 290.379 289.339 294.364C289.339 298.349 292.132 303.175 295.568 305.162C299.015 307.16 301.808 305.536 301.808 301.562Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M394.615 409.398C398.062 411.384 400.844 416.21 400.844 420.195C400.844 424.18 398.051 425.781 394.615 423.794C391.168 421.808 388.387 416.982 388.387 412.997C388.387 409.012 391.18 407.411 394.615 409.398Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M394.615 470.841C398.062 472.828 400.844 477.666 400.844 481.639C400.844 485.612 398.051 487.224 394.615 485.25C391.168 483.251 388.387 478.425 388.387 474.44C388.387 470.455 391.18 468.866 394.615 470.841Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M394.615 532.285C398.062 534.283 400.844 539.109 400.844 543.094C400.844 547.079 398.051 548.668 394.615 546.693C391.168 544.706 388.387 539.869 388.387 535.895C388.387 531.922 391.18 530.31 394.615 532.285Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M369.841 395.095C373.289 397.081 376.081 401.908 376.081 405.892C376.081 409.877 373.277 411.478 369.841 409.491C366.394 407.505 363.613 402.679 363.613 398.694C363.613 394.709 366.406 393.108 369.841 395.095Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M369.841 517.981C373.289 519.979 376.081 524.805 376.081 528.79C376.081 532.775 373.277 534.364 369.841 532.389C366.394 530.403 363.613 525.565 363.613 521.592C363.613 517.619 366.406 516.006 369.841 517.981Z",
    fill: "#FBB93E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M345.091 319.36C348.538 321.346 351.319 326.173 351.319 330.157C351.319 334.142 348.526 335.731 345.091 333.757C341.644 331.77 338.862 326.944 338.862 322.959C338.862 318.974 341.655 317.373 345.091 319.36Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M345.091 503.69C348.538 505.688 351.319 510.514 351.319 514.499C351.319 518.484 348.526 520.073 345.091 518.098C341.644 516.111 338.862 511.274 338.862 507.3C338.862 503.327 341.655 501.715 345.091 503.69Z",
    fill: "#FBB93E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M320.329 305.056C323.776 307.043 326.558 311.869 326.558 315.854C326.558 319.839 323.765 321.44 320.329 319.453C316.882 317.466 314.101 312.64 314.101 308.655C314.101 304.671 316.893 303.07 320.329 305.056Z",
    fill: "#FBB93E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M320.329 427.943C323.776 429.941 326.558 434.767 326.558 438.741C326.558 442.714 323.765 444.326 320.329 442.351C316.882 440.353 314.101 435.527 314.101 431.554C314.101 427.581 316.893 425.968 320.329 427.943Z",
    fill: "#FBB93E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M320.329 489.398C323.776 491.397 326.558 496.223 326.558 500.208C326.558 504.192 323.765 505.782 320.329 503.807C316.882 501.82 314.101 496.994 314.101 493.009C314.101 489.024 316.893 487.423 320.329 489.398Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M295.567 290.765C299.015 292.751 301.807 297.577 301.807 301.562C301.807 305.547 299.003 307.148 295.567 305.161C292.12 303.175 289.339 298.349 289.339 294.364C289.339 290.379 292.132 288.778 295.567 290.765Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M295.567 352.208C299.015 354.195 301.807 359.021 301.807 363.006C301.807 366.99 299.003 368.591 295.567 366.616C292.12 364.618 289.339 359.792 289.339 355.807C289.339 351.822 292.132 350.233 295.567 352.208Z",
    fill: "#FBB93E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M295.567 413.652C299.015 415.65 301.807 420.476 301.807 424.449C301.807 428.422 299.003 430.035 295.567 428.06C292.12 426.073 289.339 421.236 289.339 417.262C289.339 413.289 292.132 411.677 295.567 413.652Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M617.204 212.809L634.861 223.011L447.528 331.173L241.007 211.956L258.687 201.755",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M447.528 331.173V627.99",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M241.007 211.956V508.784L447.528 627.99L634.861 519.85V223.011",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M255.719 500.289V237.419L432.839 339.669V602.526L255.719 500.289Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M266.634 255.38L423.537 345.979V397.712L266.634 307.124V255.38Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M634.873 185.103L447.54 293.277L241.019 174.048L428.375 65.8853L634.873 185.103Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M353.75 182.461L421.177 221.398C428.667 225.734 441.778 225.184 450.437 220.183L513.669 183.677C522.328 178.675 523.274 171.103 515.772 166.779L448.346 127.843C440.844 123.507 427.744 124.056 419.085 129.058L355.854 165.564C347.183 170.565 346.248 178.138 353.75 182.461Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M378.968 163.881L363.859 172.611C361.931 173.721 361.931 175.52 363.859 176.63L431.285 215.567C433.201 216.677 436.31 216.677 438.226 215.567L505.653 176.63C507.569 175.52 507.569 173.721 505.653 172.611L438.226 133.674C436.31 132.575 433.201 132.575 431.285 133.674L378.968 163.881Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M490.543 185.348L416.164 142.403",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M471.951 196.087L397.572 153.142",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M453.359 206.826L378.968 163.881",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M634.873 185.102V202.608L447.54 310.782L241.019 191.553V174.048",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M447.539 293.276V310.782",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M301.807 301.562C301.807 297.577 299.003 292.751 295.567 290.764C292.12 288.766 289.339 290.379 289.339 294.364C289.339 298.348 292.132 303.174 295.567 305.161C299.015 307.159 301.807 305.535 301.807 301.562Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M326.558 315.853C326.558 311.869 323.765 307.042 320.329 305.056C316.882 303.058 314.101 304.67 314.101 308.655C314.101 312.64 316.893 317.466 320.329 319.453C323.776 321.451 326.558 319.827 326.558 315.853Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M351.319 330.145C351.319 326.16 348.526 321.334 345.091 319.347C341.644 317.349 338.862 318.962 338.862 322.947C338.862 326.931 341.655 331.758 345.091 333.744C348.538 335.731 351.319 334.118 351.319 330.145Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M266.634 316.835L423.537 407.422V459.155L266.634 368.568V316.835Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M301.807 363.005C301.807 359.021 299.003 354.194 295.567 352.208C292.12 350.221 289.339 351.834 289.339 355.807C289.339 359.78 292.132 364.618 295.567 366.616C299.015 368.603 301.807 366.99 301.807 363.005Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M376.094 405.892C376.094 401.907 373.289 397.081 369.853 395.094C366.406 393.096 363.625 394.72 363.625 398.693C363.625 402.666 366.418 407.504 369.853 409.491C373.301 411.489 376.094 409.876 376.094 405.892Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M400.844 420.183C400.844 416.198 398.051 411.372 394.615 409.386C391.168 407.387 388.387 409.012 388.387 412.985C388.387 416.958 391.18 421.796 394.615 423.782C398.062 425.781 400.844 424.168 400.844 420.183Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M266.634 378.278L423.537 468.866V520.61L266.634 430.023V378.278Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M301.807 424.449C301.807 420.475 299.003 415.649 295.567 413.651C292.12 411.664 289.339 413.277 289.339 417.262C289.339 421.247 292.132 426.073 295.567 428.059C299.015 430.046 301.807 428.433 301.807 424.449Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M326.558 438.74C326.558 434.767 323.765 429.941 320.329 427.943C316.882 425.956 314.101 427.569 314.101 431.553C314.101 435.538 316.893 440.353 320.329 442.351C323.776 444.338 326.558 442.725 326.558 438.74Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M400.844 481.627C400.844 477.653 398.051 472.816 394.615 470.829C391.168 468.842 388.387 470.455 388.387 474.428C388.387 478.401 391.18 483.239 394.615 485.237C398.062 487.224 400.844 485.611 400.844 481.627Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M266.634 439.722L423.537 530.321V582.053L266.634 491.466V439.722Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M326.558 500.195C326.558 496.21 323.765 491.384 320.329 489.386C316.882 487.399 314.101 489.012 314.101 492.997C314.101 496.982 316.893 501.808 320.329 503.794C323.776 505.781 326.558 504.168 326.558 500.195Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M351.319 514.498C351.319 510.513 348.526 505.687 345.091 503.689C341.644 501.702 338.862 503.315 338.862 507.3C338.862 511.285 341.655 516.111 345.091 518.097C348.538 520.084 351.319 518.471 351.319 514.498Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M376.094 528.79C376.094 524.805 373.289 519.979 369.853 517.981C366.406 515.994 363.625 517.607 363.625 521.591C363.625 525.576 366.418 530.402 369.853 532.389C373.301 534.376 376.094 532.763 376.094 528.79Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M400.844 543.093C400.844 539.108 398.051 534.282 394.615 532.284C391.168 530.297 388.387 531.91 388.387 535.895C388.387 539.88 391.18 544.706 394.615 546.692C398.062 548.679 400.844 547.066 400.844 543.093Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M476.648 352.301V377.11",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M485.88 346.972V371.781",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M495.112 341.644V366.452",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M476.648 401.545V426.353",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M485.88 396.216V421.025",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M495.112 390.899V415.696",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M476.648 450.788V475.597",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M485.88 445.471V470.28",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M495.112 440.131V464.94",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M476.648 500.031V524.852",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M485.88 494.715V519.512",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M495.112 489.386V514.195",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M476.648 549.286V574.084",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M485.88 543.958V568.766",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M495.112 538.629V563.426",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M392.253 493.881C400.211 500.542 400.445 512.636 392.779 519.566C386.153 525.549 375.998 525.385 369.583 519.169L341.257 490.901C347.298 478.982 353.246 469.247 362.922 467.284L381.724 485.082L392.253 493.869V493.881Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M290.085 365.981C297.248 366.25 304.376 368.797 310.827 379.268C314.122 384.631 316.015 390.018 317.406 395.487C327.97 395.558 338.545 398.724 344.435 408.283C348.057 414.184 349.822 421.617 351.364 428.546C358.668 431.573 366.813 436.668 370.377 442.487C379.48 457.293 374.677 466.77 370.26 474.237L362.933 467.308C353.257 469.271 347.309 479.005 341.268 490.924C333.322 506.606 325.188 526.051 308.174 536.522C277.78 555.207 274.554 541.161 181.56 598.339C188.676 592.66 192.801 582.458 192.427 568.634C191.598 538.17 169.196 501.745 142.389 487.232C130.178 480.641 119.17 479.753 110.873 483.586C126.333 474.074 128.109 468.92 138.136 459.373C144.516 453.285 150.008 446.308 154.355 438.631C166.275 417.492 173.45 414.979 180.531 381.067C180.555 380.179 180.59 379.279 180.601 378.356C180.601 377.012 180.59 375.622 180.543 374.173C180.344 366.799 179.491 363.878 179.363 359.227C179.304 357.38 179.456 355.709 179.772 354.167C181.233 346.957 186.398 343.182 192.077 342.937C192.334 342.937 192.603 342.925 192.836 342.949C199.813 343.089 205.025 348.067 208.928 355.347C210.014 357.334 210.984 359.507 211.872 361.786C213.66 366.39 215.098 371.508 216.278 376.697C218.113 374.979 219.959 373.32 221.805 371.695C229.413 365.058 237.102 359.39 244.475 355.219C264.867 343.65 282.828 343.521 290.096 365.969L290.085 365.981Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M244.464 355.207C237.091 359.391 229.401 365.058 221.794 371.696L211.861 361.786C210.973 359.507 210.003 357.334 208.917 355.347H208.928C211.37 347.635 220.263 341.196 228.502 340.88C228.782 340.88 229.039 340.869 229.32 340.88H229.331L244.464 355.207Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M229.319 340.869C229.039 340.857 228.782 340.869 228.501 340.869C220.263 341.184 211.37 347.635 208.928 355.324H208.916C205.013 348.056 199.801 343.078 192.825 342.937L191.341 341.5C190.85 341.009 190.383 340.495 189.985 339.981C187.414 336.592 186.772 332.198 188.01 328.319C188.688 326.203 189.915 324.264 191.668 322.651C195.372 319.297 200.561 318.467 205.013 320.209C206.298 320.711 207.49 321.401 208.601 322.335L218.545 330.679L229.296 340.869H229.319Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M128.916 132.104C188.887 174.137 227.368 272.274 218.568 330.69L208.624 322.347C207.514 321.412 206.31 320.723 205.036 320.22C200.584 318.467 195.396 319.309 191.691 322.662C189.927 324.263 188.7 326.215 188.034 328.33C186.795 332.221 187.438 336.603 190.009 339.992C190.406 340.518 190.873 341.021 191.364 341.511L192.848 342.937C192.615 342.925 192.346 342.937 192.089 342.937C186.41 343.182 181.256 346.957 179.784 354.167L176.453 353.548C190.242 283.843 128.939 161.599 63.558 139.84C63.5463 139.84 63.5463 139.828 63.5463 139.828C49.9208 135.376 38.5039 135.785 29.3657 139.992H29.354L70.5226 120.115C86.3567 112.437 107.297 116.948 128.928 132.104H128.916Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M192.416 568.611C192.802 582.435 188.665 592.637 181.548 598.316C172.971 605.152 160.047 605.397 145.416 597.486C118.621 582.984 96.2313 546.56 95.3782 516.095C94.9926 502.306 99.141 492.128 106.211 486.437C107.637 485.28 109.179 484.322 110.85 483.563C119.147 479.73 130.155 480.618 142.366 487.209C169.162 501.722 191.575 538.146 192.404 568.611H192.416Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M180.59 378.357H180.579L151.902 392.192C155.139 390.521 158.224 388.266 161.098 385.356C161.554 385.356 166.252 379.151 167.888 376.452L169.641 373.367C172.772 367.43 175.004 360.77 176.43 353.536L179.761 354.156C179.445 355.686 179.293 357.369 179.352 359.215C179.48 363.866 180.333 366.799 180.532 374.161C180.579 375.61 180.59 377.013 180.59 378.345V378.357Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5463 139.84C128.928 161.598 190.231 283.842 176.442 353.547C175.016 360.781 172.772 367.442 169.652 373.378L167.899 376.463C166.263 379.174 161.554 385.367 161.11 385.367C158.235 388.266 155.127 390.474 151.913 392.204C151.785 392.274 151.68 392.344 151.551 392.391C133.742 401.424 111.165 393.606 92.6553 380.658C77.721 370.176 62.4478 354.634 48.3316 334.523C-7.1871 255.528 -11.9198 158.993 29.354 139.992C38.5039 135.773 49.9091 135.376 63.5346 139.828C63.5346 139.828 63.5346 139.84 63.5463 139.84ZM157.441 363.141C164.768 346.501 164.896 321.459 157.441 291.789C139.106 218.788 85.5504 156.153 50.2947 151.829C39.2518 150.474 30.0084 154.844 24.2006 166.401C9.13779 196.398 18.9187 265.788 60.9638 325.63C73.5726 343.568 87.5954 358.222 101.513 367.968C113.538 376.393 125.866 381.067 135.32 380.798C141.303 380.647 146.012 378.625 150.125 374.476L150.266 374.336C153.14 371.228 155.536 367.465 157.441 363.13V363.141Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M157.441 363.142C155.536 367.466 153.14 371.229 150.266 374.349L150.125 374.489C146.012 378.649 141.303 380.659 135.32 380.811C125.866 381.08 113.538 376.405 101.513 367.98C87.5954 358.234 73.5725 343.58 60.9637 325.643C18.9186 265.8 9.13772 196.411 24.2006 166.414C30.0083 154.856 39.2517 150.486 50.2947 151.842C36.0732 182.33 47.198 251.158 90.0844 309.96C103.02 327.653 117.289 342.073 131.382 351.573C140.356 357.626 149.471 361.646 157.429 363.154L157.441 363.142Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M170.482 284.263C152.147 211.263 98.5914 148.628 63.3357 144.304C52.2927 142.948 43.0494 147.319 37.2416 158.876C22.1787 188.873 31.9597 258.263 74.0047 318.105C86.6136 336.043 100.636 350.696 114.554 360.442C126.579 368.868 138.907 373.542 148.361 373.273C154.344 373.121 159.053 371.1 163.166 366.951L163.307 366.811C166.181 363.703 168.577 359.94 170.482 355.604C177.809 338.964 177.937 313.922 170.482 284.252V284.263Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M110.862 483.563C119.17 479.741 130.166 480.618 142.378 487.209C169.173 501.722 191.586 538.146 192.416 568.611C192.802 582.435 188.677 592.637 181.548 598.316C172.971 605.152 160.047 605.398 145.416 597.486C118.621 582.984 96.2313 546.56 95.3782 516.096C94.9926 502.306 99.141 492.128 106.211 486.437C107.637 485.28 109.191 484.322 110.85 483.563H110.862Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M177.154 418.777L180.181 415.412",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M184.353 410.749C192.86 401.214 200.678 392.414 207.619 385.228C210.471 382.271 213.357 379.42 216.267 376.685C218.101 374.968 219.936 373.297 221.794 371.684C229.39 365.035 237.102 359.391 244.464 355.207C264.856 343.65 282.817 343.51 290.085 365.958",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M276.331 366.752C280.807 366.565 285.446 365.794 290.085 365.981C297.237 366.262 304.377 368.797 310.827 379.268C314.123 384.631 316.016 390.019 317.406 395.487",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M306.339 396.457C309.892 395.838 313.655 395.464 317.417 395.487C327.981 395.557 338.557 398.724 344.446 408.283C348.069 414.184 349.833 421.617 351.376 428.546",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M341.748 425.672C344.295 426.011 347.719 427.016 351.377 428.546C358.668 431.596 366.825 436.668 370.389 442.487C379.492 457.293 374.689 466.77 370.272 474.237",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M229.319 340.869L218.568 330.679L208.624 322.336C207.514 321.401 206.31 320.711 205.036 320.209C200.584 318.456 195.396 319.297 191.691 322.651C189.927 324.252 188.7 326.203 188.034 328.319C186.795 332.21 187.438 336.592 190.009 339.981C190.406 340.507 190.873 341.009 191.364 341.5L192.848 342.926",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M244.464 355.207L229.331 340.869",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M341.268 490.901L369.594 519.169C376.01 525.386 386.165 525.549 392.79 519.566C400.456 512.637 400.234 500.542 392.265 493.881L381.736 485.094L362.933 467.296C353.258 469.259 347.31 478.994 341.268 490.913C333.322 506.595 325.189 526.04 308.174 536.511C277.78 555.196 274.555 541.15 181.56 598.328",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3306 139.98L70.4992 120.115C86.3333 112.437 107.274 116.948 128.904 132.104C188.875 174.137 227.356 272.274 218.557 330.69",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M221.794 371.684L211.861 361.786",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M180.579 378.356L151.902 392.192",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M176.442 353.536C175.016 360.758 172.772 367.43 169.652 373.367L167.899 376.452C166.263 379.163 161.554 385.356 161.11 385.356C158.235 388.254 155.127 390.463 151.913 392.192C151.785 392.262 151.68 392.332 151.551 392.379C133.742 401.412 111.165 393.594 92.6553 380.647C77.721 370.165 62.4479 354.623 48.3316 334.512C-7.1871 255.528 -11.9198 159.005 29.354 139.992C38.5039 135.785 49.9091 135.376 63.5346 139.828C63.5346 139.828 63.5346 139.84 63.5463 139.84C128.928 161.599 190.196 283.831 176.442 353.548V353.536Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M157.441 363.142C155.536 367.466 153.14 371.229 150.266 374.349L150.125 374.489C146.012 378.649 141.303 380.659 135.32 380.811C125.866 381.08 113.538 376.405 101.513 367.98C87.5954 358.234 73.5725 343.58 60.9637 325.643C18.9186 265.8 9.13772 196.411 24.2006 166.414C30.0083 154.856 39.2517 150.486 50.2947 151.842C85.5504 156.165 139.106 218.801 157.441 291.801C164.896 321.471 164.768 346.513 157.441 363.154V363.142Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M157.441 363.142C149.483 361.634 140.368 357.615 131.393 351.561C117.301 342.061 103.032 327.652 90.0963 309.949C47.2099 251.146 36.0851 182.318 50.3066 151.83",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M110.862 483.562C126.322 474.05 128.098 468.897 138.124 459.35C144.505 453.261 149.997 446.285 154.344 438.607C166.264 417.468 173.439 414.956 180.52 381.044C180.544 380.156 180.579 379.256 180.59 378.333C180.59 376.989 180.579 375.598 180.532 374.149C180.333 366.776 179.48 363.854 179.352 359.203C179.293 357.357 179.445 355.686 179.761 354.143C181.221 346.933 186.386 343.159 192.066 342.913C192.323 342.913 192.591 342.902 192.825 342.925C199.802 343.065 204.99 348.055 208.916 355.324C209.991 357.31 210.973 359.484 211.861 361.762C213.649 366.367 215.086 371.485 216.267 376.673",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M208.928 355.336C211.37 347.646 220.263 341.196 228.501 340.88C228.782 340.88 229.039 340.869 229.319 340.88H229.331",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M720.681 235.059V371.665C720.681 376.83 717.923 381.586 713.459 384.168L573.137 465.208C571.408 466.178 569.854 466.26 568.65 465.559L568.591 465.524C567.142 464.683 566.231 462.743 566.231 459.985V323.858L720.681 234.685V235.059ZM697.099 366.02C702.486 362.912 705.816 354.206 703.035 350.467L665.559 299.809C665.255 299.377 664.893 299.061 664.496 298.839L653.57 292.529C650.52 290.776 645.121 294.399 642.749 300.37L605.249 394.323C603.508 398.717 604.198 402.281 606.325 403.508L617.239 409.807C618.466 410.519 620.149 410.461 622.124 409.304L697.099 366.032V366.02Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M720.681 218.991V234.697L566.231 323.87V308.165C566.231 303.105 569.316 297.192 573.137 294.995L713.798 213.78C714.031 213.651 714.265 213.534 714.51 213.429H718.332C719.781 214.282 720.692 216.234 720.692 218.991H720.681Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M703.047 350.467C705.816 354.206 702.486 362.912 697.11 366.02L622.135 409.292C620.16 410.438 618.477 410.496 617.25 409.795L617.075 409.701C615.1 408.369 614.481 404.899 616.187 400.622L653.663 306.657C656.035 300.698 661.399 297.075 664.472 298.816H664.507C664.905 299.05 665.255 299.377 665.571 299.809L703.047 350.467ZM665.314 329.69V327.364C665.314 324.139 663.047 322.842 660.242 324.443C657.473 326.067 655.194 329.982 655.194 333.195V335.544L656.584 354.592C656.69 356.053 657.484 356.859 658.594 356.859C659.085 356.859 659.646 356.707 660.23 356.368C662.147 355.281 663.713 352.664 663.876 350.385L665.325 329.69H665.314ZM663.163 370.251C664.122 368.568 664.613 366.92 664.613 365.296C664.613 363.672 664.133 362.561 663.163 362.012C662.194 361.451 661.002 361.58 659.599 362.398C658.185 363.204 656.993 364.443 656.035 366.137C655.065 367.82 654.574 369.468 654.574 371.092C654.574 372.716 655.065 373.826 656.035 374.376C656.993 374.925 658.185 374.808 659.599 373.99C661.002 373.184 662.194 371.922 663.163 370.251Z",
    fill: "#FBB93E"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M665.314 327.364V329.69L663.865 350.385C663.701 352.675 662.136 355.293 660.219 356.368C659.635 356.695 659.074 356.859 658.583 356.859C657.473 356.859 656.678 356.053 656.573 354.592L655.183 335.544V333.195C655.183 329.982 657.45 326.055 660.231 324.443C663.035 322.83 665.302 324.139 665.302 327.364H665.314Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M653.581 292.518L664.472 298.816C661.411 297.075 656.035 300.698 653.663 306.657L616.187 400.622C614.481 404.899 615.1 408.381 617.075 409.702L606.336 403.497C604.209 402.27 603.52 398.706 605.261 394.312L642.76 300.359C645.132 294.387 650.531 290.765 653.581 292.518Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M664.601 365.296C664.601 366.92 664.11 368.568 663.152 370.25C662.182 371.933 660.99 373.184 659.588 373.99C658.174 374.796 656.982 374.925 656.024 374.376C655.054 373.815 654.563 372.728 654.563 371.092C654.563 369.456 655.054 367.82 656.024 366.137C656.982 364.443 658.174 363.204 659.588 362.398C660.99 361.591 662.182 361.451 663.152 362.012C664.11 362.573 664.601 363.66 664.601 365.296Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M568.65 465.559C569.842 466.249 571.408 466.178 573.138 465.209L713.459 384.168C717.923 381.586 720.681 376.83 720.681 371.665V218.991C720.681 216.234 719.77 214.294 718.321 213.429",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M718.204 213.382C717.175 212.821 715.902 212.809 714.499 213.429C714.266 213.534 714.032 213.651 713.786 213.779L573.126 294.995C569.305 297.192 566.22 303.105 566.22 308.165V459.985C566.22 462.743 567.131 464.694 568.58 465.524",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M566.231 323.87L720.681 234.697",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M664.473 298.816C661.411 297.075 656.036 300.698 653.663 306.657L616.188 400.622C614.481 404.899 615.101 408.381 617.076 409.702",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M617.251 409.795C618.478 410.508 620.161 410.449 622.136 409.292L697.111 366.02C702.498 362.912 705.828 354.206 703.047 350.467L665.571 299.809C665.267 299.377 664.905 299.062 664.508 298.839",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M617.251 409.795L606.337 403.496C604.21 402.269 603.52 398.705 605.261 394.311L642.761 300.358C645.133 294.387 650.532 290.765 653.582 292.517L664.508 298.828",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M607.996 287.937C607.996 290.157 606.43 292.856 604.514 293.955C602.585 295.065 601.043 294.165 601.043 291.957C601.043 289.748 602.597 287.037 604.514 285.927C606.442 284.817 607.996 285.716 607.996 287.937Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M595.691 295.042C595.691 297.25 594.125 299.95 592.208 301.06C590.304 302.17 588.738 301.27 588.738 299.05C588.738 296.83 590.304 294.142 592.208 293.032C594.137 291.922 595.691 292.821 595.691 295.042Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M583.398 302.135C583.398 304.355 581.832 307.055 579.927 308.165C577.999 309.263 576.445 308.363 576.445 306.155C576.445 303.946 578.011 301.235 579.927 300.125C581.832 299.026 583.398 299.926 583.398 302.135Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M901.984 447.914L857.578 422.123L857.52 399.231L901.914 425.045L901.984 447.914Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M872.081 459.377L827.675 433.575C831.894 436.018 837.515 435.211 844.713 431.051C848.932 428.609 853.267 425.653 857.591 422.112L901.985 447.914C897.661 451.455 893.337 454.423 889.119 456.842C881.932 461.002 876.299 461.808 872.081 459.366V459.377Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M883.813 435.492L839.408 409.678L839.361 390.28L883.766 416.082L883.813 435.492Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M883.766 416.082L839.361 390.28L877.374 368.334L921.78 394.148L883.766 416.082Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M877.047 325.343C867.979 326.055 858.42 329.386 848.674 335.018C832.98 344.075 820.722 356.123 811.911 371.174C803.088 386.213 798.695 402.632 798.753 420.312C798.811 438.554 802.668 450.356 810.345 455.755C810.719 456.012 811.093 456.246 811.479 456.479C826.284 465.068 841.079 473.669 855.884 482.27C855.499 482.059 855.113 481.814 854.751 481.557C847.085 476.146 843.217 464.355 843.159 446.102C843.112 428.434 847.494 412.004 856.317 396.964C865.139 381.925 877.398 369.865 893.08 360.82C902.837 355.2 912.396 351.869 921.464 351.145L877.047 325.343Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M893.068 360.82C902.826 355.2 912.385 351.869 921.453 351.145L914.768 373.745C907.815 373.71 900.465 375.988 892.94 380.347C884.187 385.407 877.152 392.804 871.952 402.643C866.635 412.424 864.041 423.07 864.088 434.499C864.123 446.406 866.261 454.329 870.491 458.232C874.838 461.972 880.985 461.551 889.13 456.842C893.349 454.411 897.672 451.443 901.996 447.914L901.938 425.045L883.836 435.492L883.778 416.082L921.792 394.148L921.943 451.116C915.715 457.029 909.989 461.948 904.567 466.003C899.133 470.046 893.512 473.774 887.88 477.011C873.401 485.378 862.428 486.85 854.762 481.569C847.097 476.158 843.229 464.367 843.17 446.114C843.124 428.445 847.506 412.015 856.328 396.976C865.151 381.936 877.409 369.877 893.092 360.832L893.068 360.82Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M881.674 650.543L837.269 624.741L837.666 624.508L882.083 650.31L881.674 650.543Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M882.083 650.31L837.678 624.508C837.035 610.52 836.708 600.657 836.685 594.756L881.09 620.558C881.102 626.447 881.441 636.31 882.083 650.298V650.31Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M881.09 620.57L836.685 594.768L836.533 542.638L880.938 568.451L881.09 620.57Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M880.938 568.451L836.533 542.638L854.727 532.132L899.133 557.934L880.938 568.451Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M873.705 682.808L829.299 657.006L787.441 597.841L831.846 623.643L873.705 682.808Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M814.26 606.944L769.854 581.13L795.399 566.383L839.804 592.197L814.26 606.944Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M814.575 716.953L770.17 691.139L769.854 581.13L814.26 606.944L814.575 716.953Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M899.133 557.934L899.448 667.943L873.705 682.807L831.847 623.643L831.239 623.982C832.08 638.215 832.513 648.487 832.536 654.727L832.676 706.494L814.575 716.953L814.271 606.944L839.816 592.197L881.674 650.543L882.083 650.31C881.441 636.322 881.102 626.471 881.09 620.57L880.938 568.451L899.133 557.946V557.934Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M769.983 654.867L725.589 629.053C730.836 632.103 733.465 640.692 733.512 654.844C733.593 679.559 725.472 696.632 709.287 705.969C702.381 709.953 696.877 710.842 692.904 708.539L737.309 734.341C741.283 736.667 746.786 735.767 753.693 731.794C769.889 722.445 777.999 705.384 777.929 680.646C777.894 666.506 775.253 657.917 769.994 654.867H769.983Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M720.856 756.766L676.462 730.964C676.135 730.777 675.819 730.579 675.504 730.368C667.628 725.063 663.666 713.354 663.62 694.972C663.573 676.731 667.452 660.476 675.27 646.36C683.181 632.057 694.446 620.698 709.112 612.226C723.298 604.023 734.259 602.176 741.995 606.675L786.389 632.489C778.653 628.002 767.692 629.848 753.506 638.04C738.829 646.512 727.575 657.859 719.664 672.15C711.846 686.278 707.955 702.533 708.013 720.786C708.072 739.156 712.022 750.877 719.898 756.182C720.213 756.381 720.529 756.579 720.844 756.778L720.856 756.766Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M787.347 633.073C795.107 638.425 799.068 650.146 799.127 668.399C799.185 686.535 795.294 702.79 787.476 717.14C779.658 731.49 768.405 742.837 753.728 751.321C739.051 759.793 727.774 761.44 719.909 756.17C712.033 750.865 708.072 739.144 708.025 720.774C707.967 702.521 711.858 686.255 719.676 672.138C727.587 657.847 738.84 646.5 753.517 638.028C768.3 629.497 779.576 627.85 787.347 633.073ZM753.681 731.782C769.877 722.434 777.987 705.373 777.917 680.634C777.847 655.802 769.761 648.089 753.576 657.426C745.536 662.065 739.506 668.668 735.405 677.304C731.291 685.916 729.316 696.328 729.34 708.68C729.375 720.938 731.42 729.013 735.451 732.939C739.495 736.854 745.641 736.433 753.681 731.782Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M667.546 713.295L623.152 687.482C628.399 690.532 631.028 699.121 631.075 713.272C631.157 737.987 623.035 755.06 606.851 764.397C599.944 768.382 594.44 769.27 590.467 766.968L634.873 792.77C638.846 795.095 644.35 794.195 651.256 790.222C667.453 780.874 675.562 763.813 675.492 739.074C675.457 724.934 672.816 716.345 667.558 713.295H667.546Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M618.419 815.195L574.026 789.393C573.698 789.206 573.383 789.007 573.067 788.797C565.191 783.491 561.23 771.782 561.183 753.401C561.136 735.159 565.016 718.905 572.834 704.788C580.745 690.485 592.01 679.127 606.675 670.654C620.862 662.451 631.823 660.605 639.559 665.104L683.953 690.917C676.217 686.43 665.256 688.276 651.069 696.468C636.392 704.94 625.139 716.287 617.228 730.579C609.41 744.707 605.518 760.961 605.577 779.214C605.635 797.584 609.585 809.305 617.461 814.61C617.777 814.809 618.092 815.008 618.408 815.206L618.419 815.195Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M684.911 691.502C692.67 696.854 696.632 708.574 696.69 726.827C696.749 744.964 692.857 761.218 685.039 775.568C677.222 789.918 665.968 801.265 651.291 809.749C636.614 818.221 625.337 819.869 617.473 814.599C609.597 809.293 605.635 797.573 605.589 779.203C605.53 760.95 609.421 744.683 617.239 730.567C625.15 716.275 636.404 704.928 651.081 696.456C665.863 687.926 677.14 686.278 684.911 691.502ZM651.233 790.211C667.429 780.862 675.539 763.801 675.469 739.062C675.399 714.23 667.312 706.518 651.128 715.855C643.088 720.494 637.058 727.096 632.956 735.732C628.843 744.344 626.868 754.756 626.892 767.108C626.927 779.366 628.972 787.441 633.003 791.367C637.046 795.282 643.193 794.861 651.233 790.211Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M532.46 874.85L488.054 849.06L487.984 827.324L532.389 853.138L532.46 874.85Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M573.301 821.189C572.88 820.769 572.413 820.406 571.875 820.091L527.47 794.277C528.007 794.604 528.486 794.955 528.907 795.376C529.912 796.404 530.426 798.087 530.438 800.284C530.438 804.081 529.246 807.681 526.932 810.988C524.525 814.341 521.101 817.228 516.684 819.787C512.968 821.937 508.843 823.737 504.414 824.905C499.88 826.132 494.446 826.95 487.996 827.312L532.401 853.126C538.852 852.752 544.286 851.946 548.82 850.696C553.248 849.539 557.373 847.739 561.09 845.589C565.518 843.041 568.931 840.132 571.338 836.79C573.652 833.483 574.855 829.883 574.832 826.074C574.832 823.877 574.318 822.218 573.313 821.189H573.301Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M555.913 792.781C541.107 784.181 526.313 775.58 511.519 766.979C512.208 767.388 513.038 767.692 514.02 767.868C515.831 768.206 520.061 768.3 526.909 768.171C534.341 767.914 539.857 768.849 543.409 770.929L587.815 796.731C584.251 794.663 578.747 793.728 571.303 793.997C564.455 794.125 560.225 794.032 558.414 793.67C557.432 793.494 556.602 793.19 555.901 792.793L555.913 792.781Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M549.707 714.593C544.776 714.896 540.043 715.773 535.521 717C530.987 718.238 526.266 720.389 521.229 723.287C511.075 729.153 503.14 736.503 497.426 745.361C491.7 754.219 488.919 763.462 488.93 773.173C488.942 778.373 489.76 782.416 491.583 785.303C493.009 787.628 494.831 789.393 497.052 790.69C511.858 799.302 526.652 807.903 541.457 816.492C539.225 815.206 537.402 813.43 535.988 811.105C534.165 808.218 533.347 804.175 533.336 798.975C533.312 789.276 536.105 780.021 541.82 771.151C547.534 762.305 555.48 754.931 565.635 749.077C570.66 746.167 575.393 744.029 579.915 742.802C584.449 741.563 589.182 740.675 594.113 740.383L549.707 714.581V714.593Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M565.635 749.1C570.66 746.191 575.393 744.052 579.915 742.825C584.449 741.586 589.182 740.698 594.113 740.406L587.534 762.387C582.498 762.866 578.268 763.555 574.949 764.549C571.525 765.589 568.3 766.991 565.086 768.849C561.16 771.116 558.25 773.734 556.252 776.959C554.137 780.266 553.143 783.491 553.155 786.857C553.155 788.948 553.576 790.433 554.382 791.484C555.294 792.583 556.602 793.331 558.425 793.658C560.237 794.008 564.467 794.102 571.315 793.985C580.278 793.681 586.424 795.083 589.755 798.133C593.085 801.066 594.721 806.278 594.733 813.442C594.756 823.374 591.671 832.91 585.443 842.294C579.331 851.514 570.59 859.448 559.512 865.829C549.357 871.695 540.313 874.721 532.448 874.862L532.39 853.15C538.84 852.776 544.274 851.969 548.808 850.719C553.237 849.562 557.362 847.762 561.078 845.612C565.507 843.065 568.919 840.155 571.326 836.813C573.64 833.506 574.844 829.907 574.82 826.097C574.82 823.9 574.306 822.241 573.301 821.213C572.191 820.102 570.684 819.343 568.662 819.004C566.652 818.548 562.41 818.572 556.182 818.7C550.339 818.957 546.003 818.455 542.977 817.298C540.055 815.977 537.73 813.956 536.012 811.14C534.189 808.253 533.371 804.21 533.36 799.01C533.336 789.311 536.129 780.056 541.843 771.186C547.558 762.34 555.504 754.966 565.659 749.112L565.635 749.1Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M807.038 494.166L762.632 468.364L763.03 468.142L807.447 493.932L807.038 494.166Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M807.447 493.932L763.042 468.13C762.399 454.142 762.072 444.279 762.048 438.378L806.454 464.18C806.466 470.07 806.804 479.932 807.447 493.92V493.932Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M806.454 464.192L762.048 438.39L761.896 386.26L806.302 412.074L806.454 464.192Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M806.302 412.074L761.896 386.26L780.091 375.755L824.497 401.568L806.302 412.074Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M799.068 526.442L754.663 500.64L712.805 441.463L757.21 467.277L799.068 526.442Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M739.623 450.578L695.218 424.764L720.763 410.005L765.168 435.819L739.623 450.578Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M739.939 560.587L695.533 534.773L695.218 424.764L739.623 450.578L739.939 560.587Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M824.497 401.568L824.812 511.577L799.069 526.442L757.21 467.277L756.603 467.616C757.444 481.849 757.877 492.121 757.9 498.361L758.04 550.128L739.939 560.587L739.635 450.578L765.18 435.831L807.038 494.177L807.447 493.944C806.805 479.956 806.466 470.105 806.454 464.204L806.302 412.085L824.497 401.58V401.568Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M690.263 588.153L645.858 562.352L645.554 452.343L689.948 478.133L690.263 588.153Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M689.948 478.133L645.554 452.342L665.863 440.598L710.257 466.412L689.948 478.133Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M710.257 466.412L710.585 576.421L690.263 588.154L689.948 478.133L710.257 466.412Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M646.629 614.855L602.223 589.065L602.083 536.935L646.477 562.749L646.629 614.855Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M646.477 562.749L602.083 536.935C602.083 534.528 602.071 531.758 602.153 528.463L646.559 554.253C646.465 557.549 646.489 560.306 646.489 562.749H646.477Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M613.371 608.148L568.966 582.346L569.375 582.112L613.769 607.902L613.371 608.148Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M646.547 554.253L602.142 528.463C602.142 525.214 602.422 516.497 602.878 502.451L647.283 528.253C646.828 542.311 646.535 551.028 646.547 554.253Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M613.769 607.902L569.375 582.112L593.167 484.104L637.561 509.918L613.769 607.902Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M637.561 509.918L593.167 484.104L620.815 468.13L665.221 493.944L637.561 509.918Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M603.684 639.652L559.278 613.862L536 540.826L580.418 566.64L603.684 639.652Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M563.158 663.047L518.753 637.257L518.437 527.236L562.843 553.038L563.158 663.047Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M562.843 553.038L518.437 527.236L546.097 511.262L590.503 537.075L562.843 553.038Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M665.221 493.944L665.537 603.953L646.629 614.855L646.477 562.749C646.477 560.318 646.466 557.549 646.547 554.253C646.547 551.028 646.828 542.311 647.284 528.253L646.676 528.603L622.276 628.913L603.673 639.652L580.406 566.64L579.81 566.991C580.652 584.075 581.096 595.621 581.108 601.417L581.259 652.6L563.158 663.047L562.854 553.038L590.514 537.075L613.383 608.148L613.781 607.902L637.573 509.906L665.233 493.944H665.221Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M510.093 606.43L465.699 580.616C470.946 583.666 473.576 592.255 473.622 606.407C473.704 631.122 465.583 648.195 449.398 657.531C442.492 661.516 436.988 662.404 433.015 660.102L477.42 685.904C481.393 688.23 486.897 687.33 493.804 683.357C510 674.008 518.11 656.947 518.04 632.209C518.005 618.069 515.364 609.48 510.105 606.43H510.093Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M460.979 708.329L416.585 682.527C416.257 682.34 415.942 682.141 415.626 681.931C407.75 676.626 403.789 664.917 403.742 646.535C403.695 628.294 407.575 612.039 415.393 597.923C423.304 583.619 434.569 572.261 449.234 563.789C463.421 555.586 474.382 553.739 482.118 558.238L526.512 584.052C518.776 579.565 507.815 581.411 493.628 589.603C478.951 598.075 467.698 609.421 459.787 623.713C451.969 637.841 448.078 654.096 448.136 672.349C448.194 690.719 452.144 702.439 460.02 707.745C460.336 707.943 460.651 708.142 460.967 708.341L460.979 708.329Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M527.47 584.636C535.229 589.988 539.191 601.709 539.249 619.962C539.308 638.098 535.416 654.353 527.599 668.703C519.781 683.053 508.528 694.4 493.85 702.883C479.173 711.356 467.896 713.003 460.032 707.733C452.156 702.428 448.194 690.707 448.148 672.337C448.089 654.084 451.981 637.818 459.798 623.701C467.709 609.41 478.963 598.063 493.64 589.591C508.422 581.06 519.699 579.413 527.47 584.636ZM493.792 683.345C509.988 673.996 518.098 656.935 518.028 632.197C517.958 607.365 509.871 599.652 493.687 608.989C485.647 613.628 479.617 620.231 475.515 628.866C471.402 637.479 469.427 647.891 469.451 660.242C469.486 672.501 471.531 680.576 475.562 684.502C479.605 688.417 485.752 687.996 493.792 683.345Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M383.432 739.343L339.026 713.553C342.976 715.843 348.398 715.002 355.305 711.017C362.047 707.125 370.18 700.453 379.728 691.128L424.133 716.918C414.586 726.255 406.453 732.916 399.71 736.807C392.804 740.792 387.382 741.633 383.432 739.343Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M383.117 608.825C373.639 609.199 364.396 611.875 355.036 617.274C345.886 622.568 337.951 629.474 331.22 637.981C324.396 646.547 319.289 656.082 315.69 666.728C311.997 677.549 310.21 688.545 310.245 699.974C310.303 718.122 314.066 729.948 321.44 735.428C321.895 735.767 322.374 736.071 322.865 736.363L367.271 762.153C366.78 761.873 366.301 761.569 365.833 761.23C358.471 755.761 354.709 743.912 354.65 725.776C354.627 714.335 356.403 703.351 360.096 692.53C363.695 681.884 368.813 672.349 375.626 663.771C382.345 655.264 390.292 648.358 399.441 643.088C408.802 637.689 418.057 635.001 427.522 634.639L383.128 608.825H383.117Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M399.43 643.088C408.79 637.689 418.045 635.001 427.51 634.639L421.036 657.461C417.402 657.602 413.78 657.952 410.157 658.536C406.535 659.226 403.017 660.453 399.488 662.509C391.857 666.903 385.933 673.693 381.819 682.656C377.612 691.689 375.532 702.147 375.556 713.926C375.626 738.431 383.712 746.027 399.698 736.795C406.441 732.904 414.574 726.243 424.121 716.906L424.18 736.421C416.351 744.753 407.61 751.683 397.852 757.304C383.981 765.32 373.3 766.606 365.833 761.207C358.471 755.738 354.709 743.889 354.65 725.752C354.627 714.312 356.403 703.328 360.096 692.507C363.695 681.861 368.813 672.325 375.626 663.748C382.345 655.241 390.291 648.335 399.441 643.065L399.43 643.088Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoonDark);
export default __webpack_public_path__ + "static/media/ComingSoonDark.4311c344f350e473549429665b0dadf8.svg";
export { ForwardRef as ReactComponent };